import React from "react";
import {isEmpty} from "../../../_helpers/commonFunctions";
import {epayLogoBase64, vivaLogoBase64} from "./print-constants";

const ThermalPrint110 = React.forwardRef((props, ref) => {
    require('./scss/thermal-print-template-110mm.css')
    let templateData = [];
    if (!props.data) return(<div></div>);
    templateData = props.data;

    const styles = {
        strong: {
            fontWeight: "bold"
        },
        section: {
            width: "100%",
            overflowWrap: "break-word"
        },
        qr: {
            width: "70mm",
            margin: "30px"
        },
        totals_per_vat: {
            fontSize: "16pt",
            borderCollapse: "collapse",
            width: "100%"
        },
        total_per_vat_text: {
            textAlign: "center"
        },
        totals_per_other_tax: {
            borderCollapse: "collapse",
            borderBottom: "thin dashed black"
        },
        totals_per_vat_tbody: {
            borderBottom: "thin dashed black"
        },
        total: {
            fontWeight: "bolder"
        },
        desc: {
            width: "15mm",
            maxWidth: "15mm",
            textOverflow: "",
            overflowWrap: "break-word"
        },
        tdtable: {
            width: "15mm",
            textAlign: "right",
            padding: "0 5px 0 5px"
        },
        cont_notation: {
            maxWidth: "100%"
        }
    }

    if (!isEmpty(templateData.BRANCH)) {
        templateData.ISSUER_ADDRESS = templateData.BRANCH.address;
        templateData.ISSUER_CITY = templateData.BRANCH.city;
        templateData.ISSUER_TK = templateData.BRANCH.postalCode;
        templateData.ISSUER_PHONE = templateData.BRANCH.phone;
        templateData.ISSUER_DOY = templateData.BRANCH.doy;
    }

    return (
        <React.Fragment>
            <div ref={ref} style={styles} className="print-template-thermal print-template-thermal-110mm">
                {templateData.MYDATAENVIRONMENT === "test" && <p style={{textAlign: "center", borderBottom: "thin dashed black"}}>
                    <strong style={styles.strong}>--- ΑΚΥΡΟ ΠΑΡΑΣΤΑΤΙΚΟ ---</strong>
                    <div>Αυτή η απόδειξη είναι άκυρη και εκδίδεται μόνο για λόγους δοκιμής της εφαρμογής</div>
                </p>}
                <div>{templateData.ISSUER_NAME}</div>
                <div>{templateData.ISSUER_SMALL_NAME}</div>
                <div>{templateData.ISSUER_SUBJECTFIELD}</div>
                <div>ΔΟΥ: {templateData.ISSUER_DOY}</div>
                <div>{templateData.ISSUER_ADDRESS ? `${templateData.ISSUER_ADDRESS}, ` : ""}{templateData.ISSUER_CITY ? `${templateData.ISSUER_CITY}, ` : ""}{templateData.ISSUER_TK ? `${templateData.ISSUER_TK}` : ""}</div>
                <div>ΑΦΜ: {templateData.ISSUER_VAT}</div>
                {!isEmpty(templateData.ISSUER_GEMH) && <div>ΓΕΜΗ: {templateData.ISSUER_GEMH}</div>}
                {!isEmpty(templateData.ISSUER_AMKA) && <div>ΑΜΚΑ: {templateData.ISSUER_AMKA}</div>}
                <div>ΤΗΛ.: {templateData.ISSUER_PHONE}</div>
                <div>Email: {templateData.ISSUER_EMAIL}</div>
                <div style={{borderTop: "thin dashed black", marginBottom: "8px"}}></div>
                <div style={{fontWeight: "bold"}}>ΣΤΟΙΧΕΙΑ ΠΕΛΑΤΗ</div>
                <div>ΕΠΩΝΥΜΙΑ: {templateData.CUSTOMER_NAME}</div>
                <div>{templateData.CUSTOMER_ACTIVITY}</div>
                {templateData.CUSTOMER_DOY && <div>ΔΟΥ: {templateData.CUSTOMER_DOY}</div>}
                {templateData.CUSTOMER_AMKA && <div>ΑΜΚΑ: {templateData.CUSTOMER_AMKA}</div>}
                <div>{templateData.CUSTOMER_ADDRESS ? `${templateData.CUSTOMER_ADDRESS}, ` : ""}{templateData.CUSTOMER_CITY ? `${templateData.CUSTOMER_CITY}, ` : ""}{templateData.CUSTOMER_ZIP ? `${templateData.CUSTOMER_ZIP}` : ""}</div>
                {(templateData.CUSTOMER_VAT || templateData.CUSTOMER_PHONE) &&
                    <>
                        <div>ΑΦΜ: {templateData.CUSTOMER_VAT}</div>
                        <div>ΤΗΛ.: {templateData.CUSTOMER_PHONE}</div>
                    </>}
                {templateData.CUSTOMER_EMAIL && <div>EMAIL: {templateData.CUSTOMER_EMAIL}</div>}
                <div style={{borderTop: "thin dashed black", marginBottom: "8px"}}></div>
                <strong style={styles.strong}>
                    {templateData.INVOICE_TYPE}
                </strong>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <span style={{textAlign: "left"}}>
                        Σειρά-Αρ.Παρ: {!isEmpty(templateData.SERIES) ? `${templateData.SERIES} - ` : ""}{templateData.NUMBER}
                    </span>
                    <span style={{textAlign: "right"}}>{templateData.INVOICE_DATE} {templateData.INVOICE_TIME}
                    </span>
                </div>
                {templateData.PURPOSE && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{textAlign: "left"}}>
                        Σκ.Διακ: {templateData.PURPOSE}
                    </div>
                    { templateData.DISPATCH_TIME &&
                        <div style={{textAlign: "left"}}>
                            Παράδοση:
                            <br/>
                            {templateData.DISPATCH_TIME}
                            <br/>
                            {templateData.VEHICLE_NUMBER && <span>Όχημα: {templateData.VEHICLE_NUMBER}</span>}
                        </div>
                    }
                </div>}
                {templateData.REVERSE_DELIVERY_NOTE_PURPOSE && (
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <div style={{textAlign: "left"}}>
                            Αιτία Αντιστρ. Διακίνησης : {templateData.REVERSE_DELIVERY_NOTE_PURPOSE}
                        </div>
                    </div>
                )}
                {templateData.VAT_PAYMENT_SUSPENSION && (
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <div style={{textAlign: "left"}}>
                            Με αναστολή καταβολής Φ.Π.Α.
                        </div>
                    </div>
                )}
                {templateData.WAY_OF_SENDING &&
                    <div style={{textAlign: "left"}}>
                        Μέθοδος Αποστολής: {templateData.WAY_OF_SENDING}
                    </div>}
                {templateData.LOCATION_NAME && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <span style={{textAlign: "left"}}>
                        Τόπος Αποστ: {templateData.LOCATION_NAME}
                        <br/>
                        Διεύθυνση:
                        <br/>
                        {templateData.LOCATION_ADDRESS}
                    </span>
                    <span style={{textAlign: "right"}}>
                        {templateData.LOCATION_CITY}
                        <br/>
                        {templateData.LOCATION_ZIP}
                    </span>
                </div>}
                <div style={{borderTop: "thin dashed black", marginBottom: "8px"}}></div>
                {/*{templateData.TABLE_AA && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>*/}
                {/*    <span style={{textAlign: "left"}}>*/}
                {/*        Αρ.Τραπεζιού: {templateData.TABLE_AA}*/}
                {/*    </span>*/}
                {/*</div>}*/}
                {/*{templateData.SELF_PRICING && <div>{templateData.SELF_PRICING}</div>}*/}
                {templateData.CORRELATION && <div style={{alignItems: "left"}}>
                    {templateData.CORRELATION}
                </div>}
                {!isEmpty(templateData.PAYMENT_METHOD) &&
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left", fontWeight: "bold"}}>
                                Τρόπος Πληρωμής:
                            </span>
                        <span style={{textAlign: "right", fontWeight: "bold"}}>
                                {templateData.PAYMENT_METHOD}
                            </span>
                    </div>
                }
                {templateData.TRANSACTION_DETAILS && templateData.TRANSACTION_DETAILS.providerSignature &&
                    <div>
                        {templateData.TRANSACTION_DETAILS?.PAYMENT_METHOD && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    Τρ. Πληρωμής:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.PAYMENT_METHOD}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS?.transactionDate && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    Ημερομ. Συν.:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.transactionDate}
                                </span>
                        </div>}
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                Ψηφ. Υπογραφή:
                            </span>
                            <span style={{textAlign: "right", wordBreak: "break-all", padding: "2px 0 2px 10px"}}>
                                {templateData.TRANSACTION_DETAILS.providerSignature}
                            </span>
                        </div>
                        {templateData.TRANSACTION_DETAILS.tid && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    tid:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.tid}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.transactionNumber && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    Αρ.Συν.:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.transactionNumber}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.authorizationCode && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    Έγκριση:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.authorizationCode}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.rnn && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    rnn:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.rnn}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.cardType && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    Κάρτα:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.cardType}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.aid && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    aid:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.aid}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.tipAmountString && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    Φιλοδώρημα:
                                </span>
                            <span style={{textAlign: "right"}}>
                                    {templateData.TRANSACTION_DETAILS.tipAmountString}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.providerTransactionId && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>
                                    ΤΑΥΤ. ΠΛΗΡΩΜΗΣ:
                                </span>
                            <span style={{textAlign: "right", wordBreak: "break-all", padding: "2px 0 2px 2px"}}>
                                    {templateData.TRANSACTION_DETAILS.providerTransactionId}
                                </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.isEuronet === "true" && <div>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>ΜΕΣΩ:</span>
                                <span style={{
                                    textAlign: "right",
                                    wordBreak: "break-all",
                                    padding: "2px 0 2px 2px"
                                }}>EPAY</span>
                            </div>
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <img style={{margin: "0", width: "40mm"}} className={"mb-1"} src={epayLogoBase64} alt={"ePay Logo"}/>
                                &nbsp;&nbsp;
                                <span style={{fontSize: "8px"}}>ΓΕΜΗ: 159277401000</span>
                            </div>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.isEuronet === "viva" && <div>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{textAlign: "left"}}>ΜΕΣΩ:</span>
                                <span style={{
                                    textAlign: "right",
                                    wordBreak: "break-all",
                                    padding: "2px 0 2px 2px"
                                }}>VIVA</span>
                            </div>
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <img style={{margin: "0", width: "40mm"}} src={vivaLogoBase64} alt={"Viva Logo"}/>
                            </div>
                        </div>}
                    </div>}
                {templateData.TRANSACTION_DETAILS && !templateData.TRANSACTION_DETAILS.providerSignature &&
                    <div>
                        {templateData.TRANSACTION_DETAILS.paymentTypeName && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                ΤΡΟΠΟΣ ΠΛΗΡΩΜΗΣ:
                            </span>
                            <span style={{textAlign: "right", wordBreak: "break-all", padding: "2px 0 2px 2px"}}>
                                {templateData.TRANSACTION_DETAILS.paymentTypeName}
                            </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.paymentDate && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                HM/NIA ΠΛΗΡΩΜΗΣ:
                            </span>
                            <span style={{textAlign: "right", wordBreak: "break-all", padding: "2px 0 2px 2px"}}>
                                {templateData.TRANSACTION_DETAILS.paymentDate}
                            </span>
                        </div>}
                        {templateData.TRANSACTION_DETAILS.paymentAmount && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                ΠΟΣΟ:
                            </span>
                            <span style={{textAlign: "right", wordBreak: "break-all", padding: "2px 0 2px 2px"}}>
                                {templateData.TRANSACTION_DETAILS.paymentAmount}
                            </span>
                        </div>}
                    </div>
                }
                <div style={{borderTop: "thin dashed black", marginBottom: "8px"}}></div>
                <section style={styles.section}>
                    <table style={styles.totals_per_vat}>
                        <tbody style={styles.totals_per_vat_tbody}>
                        <tr>
                            <th colSpan="2" style={{textAlign: "left"}}>Είδος</th>
                            <th style={{textAlign: "center"}}>Ποσ.</th>
                            <th style={{textAlign: "center"}}>Φ.Π.Α</th>
                            <th style={{textAlign: "center"}}>Αξία</th>
                        </tr>
                        {templateData.PRODUCT_DETAILS && templateData.PRODUCT_DETAILS[0]?.length > 0 && templateData.PRODUCT_DETAILS[0].map((product) => (
                            <tr>
                                <td colSpan="2" style={styles.desc}>{product.PRODUCT_DESCRIPTION}</td>
                                <td style={styles.tdtable}>{product.QTY}</td>
                                <td style={styles.tdtable}>{product.VAT} ({product.VAT_ID})</td>
                                <td style={styles.tdtable}>{product.TOTAL}</td>
                            </tr>))}
                        </tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                    <table style={styles.totals_per_vat}>
                        <tbody style={styles.totals_per_vat_tbody}>
                        <tr>
                            <td align="left" colSpan="1">
                                ΑΞΙΑ ΠΡΟ ΕΚΠΤ.
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.TOTAL_WITHOUT_DISCOUNT}
                            </td>
                        </tr>
                        <tr>
                            <td align="left" colSpan="1">
                                ΕΚΠΤΩΣΗ
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.TOTAL_DISCOUNT}
                            </td>
                        </tr>
                        <tr>
                            <td align="left" colSpan="1">
                                ΚΑΘΑΡΗ ΑΞΙΑ
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.TOTAL_NOVAT}
                            </td>
                        </tr>
                        <tr>
                            <td align="left">
                                ΑΞΙΑ Φ.Π.Α.
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.TOTAL_VAT}
                            </td>
                        </tr>
                        {(parseFloat(templateData.TOTAL_DEDUCTIONS) > 0) && <tr>
                            <td align="left">
                                ΚΡΑΤΗΣΕΙΣ
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.TOTAL_DEDUCTIONS}
                            </td>
                        </tr>}
                        {(parseFloat(templateData.TOTAL_WITHHOLD) > 0) && <tr>
                            <td align="left">
                                ΠΑΡΑΚΡΑΤΗΣΕΙΣ
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.TOTAL_WITHHOLD}
                            </td>
                        </tr>}
                        {(parseFloat(templateData.TOTAL_TAXES_AMOUNT) > 0) && <tr>
                            <td align="left">
                                ΣΥΝΟΛΟ ΕΠΙΒΑΡΥΝΣΕΩΝ
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.TOTAL_TAXES_AMOUNT}
                            </td>
                        </tr>}
                        <tr>
                            <td align="left">
                                ΑΞΙΑ ΜΕ Φ.Π.Α.
                            </td>
                            <td></td>
                            <td align="right">
                                {templateData.PRICE_WITHVAT}
                            </td>
                        </tr>


                        <tr style={styles.total}>
                            <td colSpan="1" align="left">
                                ΠΛΗΡΩΤΕΟ ΠΟΣΟ:
                            </td>
                            <td></td>
                            <td align="right" colSpan="1">
                                {templateData.TOTAL_PRICE}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <section style={styles.section}>
                    <table style={styles.totals_per_vat}>
                        <tbody style={styles.totals_per_vat_tbody}>
                        <tr>
                            <th style={styles.total_per_vat_text}>Συντελεστής ΦΠΑ</th>
                            <th style={styles.total_per_vat_text}>Καθαρή Αξία</th>
                            <th style={styles.total_per_vat_text}>Αξία ΦΠΑ</th>
                            <th style={styles.total_per_vat_text}>Τελική Αξία</th>
                        </tr>
                        {!isEmpty(templateData.VAT_TABLE) && templateData.VAT_TABLE.map((el) => (
                            <tr>
                                <td style={styles.total_per_vat_text}>{el.TAX_PERCENT}</td>
                                <td style={styles.total_per_vat_text}>{el.NET_VALUE}</td>
                                <td style={styles.total_per_vat_text}>{el.TAX_VALUE}</td>
                                <td style={styles.total_per_vat_text}>{el.TOTAL_VALUE}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div style={styles.cont_notation}>
                        <span style={{fontWeight: "bold"}}>ΠΑΡΑΤΗΡΗΣΕΙΣ :</span>
                        <div>
                            {templateData.INVOICE_NOTES && <span>{templateData.INVOICE_NOTES}</span>}
                        </div>
                    </div>
                </section>

                {templateData.ENABLE_PEPPOL && <section style={styles.section}>
                    <div style={{borderTop: "thin dashed black", marginBottom: "8px"}}></div>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                Αρ. Τιμολογίου:
                            </span>
                        <span style={{textAlign: "right"}}>
                                {templateData.PEPPOL?.DOCUMENT_REFERENCE}
                            </span>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                Α.Δ.Α.:
                            </span>
                        <span style={{textAlign: "right"}}>
                                {templateData.PEPPOL?.PROJECT_REFERENCE}
                            </span>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                Αναθέτουσα Αρχή:
                            </span>
                        <span style={{textAlign: "right"}}>
                                {templateData.PEPPOL?.PARTY_IDENTIFICATION}
                            </span>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{textAlign: "left"}}>
                                Α.Δ.Α.Μ.:
                            </span>
                        <span style={{textAlign: "right"}}>
                                {templateData.PEPPOL?.CONTRACT_DOCUMENT_REFERENCE}
                            </span>
                    </div>
                    <div style={{borderTop: "thin dashed black", marginBottom: "8px"}}></div>
                </section>}
                <div style={{textAlign: "center", fontSize: "8pt", marginTop: "10px"}}>
                    {templateData.QR_CODE && <img style={styles.qr}
                                                  src={templateData.QR_CODE}
                                                  alt="QR Code"/>}
                    {templateData.MARK && <div style={{
                        marginTop: "10px",
                        // paddingRight: "4mm",
                        wordBreak: "break-all",
                        textAlign: "center",
                        fontSize: "16pt"
                    }}>Μ.ΑΡ.Κ:{templateData.MARK}
                    </div>}
                    {templateData.AUTHCODE && <div style={{
                        paddingRight: "2mm",
                        wordBreak: "break-all",
                        textAlign: "left",
                        fontSize: "16pt"
                    }}>AUTH CODE: {templateData.AUTHCODE}
                    </div>}
                    {templateData.UID && <div style={{paddingRight: "2mm", wordBreak: "break-all", textAlign: "left", fontSize: "16pt"}}>
                        UID: {templateData.UID}
                    </div>}
                </div>
                {!templateData.TRANSACTION_DETAILS && templateData.PAYMENT_HISTORY && !isEmpty(templateData.PAYMENT_HISTORY) &&
                    <div>
                        <div style={{borderTop: "thin dashed black", marginBottom: "8px"}}></div>
                        <div style={{marginBottom: "4px", textAlign: "center", textDecoration: "underline"}}>Ιστορικό Πληρωμών</div>
                        {Object.values(templateData.PAYMENT_HISTORY).flat().map((transDetails) => {
                                if (transDetails.providerSignature) {
                                    return (
                                        <div>
                                            {transDetails?.PAYMENT_METHOD && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                            <span style={{textAlign: "left"}}>
                                                Τρ. Πληρωμής:
                                            </span>
                                                <span style={{textAlign: "right"}}>
                                                {transDetails.PAYMENT_METHOD}
                                            </span>
                                            </div>}
                                            {transDetails?.transactionDate && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                            <span style={{textAlign: "left"}}>
                                                Ημερομ. Συν.:
                                            </span>
                                                <span style={{textAlign: "right"}}>
                                                {transDetails.transactionDate}
                                            </span>
                                            </div>}
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Ψηφ. Υπογραφή:
                                                </span>
                                                <span style={{
                                                    textAlign: "right",
                                                    wordBreak: "break-all",
                                                    padding: "2px 0 2px 10px"
                                                }}>
                                                    {transDetails.providerSignature}
                                                </span>
                                            </div>
                                            {transDetails.tid && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    tid:
                                                </span>
                                                <span style={{textAlign: "right"}}>
                                                    {transDetails.tid}
                                                </span>
                                            </div>}
                                            {transDetails.transactionNumber && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Αρ.Συν.:
                                                </span>
                                                <span style={{textAlign: "right"}}>
                                                    {transDetails.transactionNumber}
                                                </span>
                                            </div>}
                                            {transDetails.authorizationCode && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Έγκριση:
                                                </span>
                                                <span style={{textAlign: "right"}}>
                                                    {transDetails.authorizationCode}
                                                </span>
                                            </div>}
                                            {transDetails.rnn && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    rnn:
                                                </span>
                                                <span style={{textAlign: "right"}}>
                                                    {transDetails.rnn}
                                                </span>
                                            </div>}
                                            {transDetails.cardType && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Κάρτα:
                                                </span>
                                                <span style={{textAlign: "right"}}>
                                                    {transDetails.cardType}
                                                </span>
                                            </div>}
                                            {transDetails.aid && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    aid:
                                                </span>
                                                <span style={{textAlign: "right"}}>
                                                    {transDetails.aid}
                                                </span>
                                            </div>}
                                            {transDetails.tipAmountString && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Φιλοδώρημα:
                                                </span>
                                                <span style={{textAlign: "right"}}>
                                                    {transDetails.tipAmountString}
                                                </span>
                                            </div>}
                                            {transDetails.providerTransactionId && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    ΤΑΥΤ. ΠΛΗΡΩΜΗΣ:
                                                </span>
                                                <span style={{
                                                    textAlign: "right",
                                                    wordBreak: "break-all",
                                                    padding: "2px 0 2px 2px"
                                                }}>
                                                    {transDetails.providerTransactionId}
                                                </span>
                                            </div>}
                                            {transDetails.isEuronet === "true" && <div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}>
                                                    <span style={{textAlign: "left"}}>ΜΕΣΩ:</span>
                                                    <span style={{
                                                        textAlign: "right",
                                                        wordBreak: "break-all",
                                                        padding: "2px 0 2px 2px"
                                                    }}>EPAY</span>
                                                </div>
                                                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                    <img style={{margin: "0", width: "40mm"}} className={"mb-1"}
                                                         src={epayLogoBase64} alt={"ePay Logo"}/>
                                                    &nbsp;&nbsp;
                                                    <span style={{fontSize: "8px"}}>ΓΕΜΗ: 159277401000</span>
                                                </div>
                                            </div>}
                                            {transDetails.isEuronet === "viva" && <div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}>
                                                    <span style={{textAlign: "left"}}>ΜΕΣΩ:</span>
                                                    <span style={{
                                                        textAlign: "right",
                                                        wordBreak: "break-all",
                                                        padding: "2px 0 2px 2px"
                                                    }}>VIVA</span>
                                                </div>
                                                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                    <img style={{margin: "0", width: "40mm"}} src={vivaLogoBase64}
                                                         alt={"Viva Logo"}/>
                                                </div>
                                            </div>}
                                            <div style={{borderTop: "thin dashed black"}}></div>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div>
                                            {transDetails.paymentTypeName && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Τρόπος Πληρωμής:
                                                </span>
                                                <span style={{
                                                    textAlign: "right",
                                                    wordBreak: "break-all",
                                                    padding: "2px 0 2px 2px"
                                                }}>
                                                    {transDetails.paymentTypeName}
                                                </span>
                                            </div>}
                                            {transDetails.paymentDate && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Ημ/νία:
                                                </span>
                                                <span style={{
                                                    textAlign: "right",
                                                    wordBreak: "break-all",
                                                    padding: "2px 0 2px 2px"
                                                }}>
                                                    {transDetails.paymentDate}
                                                </span>
                                            </div>}
                                            {transDetails.paymentAmount && <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <span style={{textAlign: "left"}}>
                                                    Ποσό:
                                                </span>
                                                <span style={{
                                                    textAlign: "right",
                                                    wordBreak: "break-all",
                                                    padding: "2px 0 2px 2px"
                                                }}>
                                                    {transDetails.paymentAmount}
                                                </span>
                                            </div>}
                                            <div style={{borderTop: "thin dashed black"}}></div>
                                        </div>
                                    )
                                }
                        })
                        }
                    </div>
                }
                <br/>
                <div style={{textAlign: "center"}}>Provided by Primer Software P.C.</div>
                <div style={{textAlign: "center"}}>www.primer.gr/search-invoice</div>
                <div style={{textAlign: "center"}}>Άδεια ΥΠΑΗΕΣ: 2021_01_107Primer Software ΙΚΕ_001_ Primer
                    MyData_V1_21012021
                </div>
                {templateData.SHOW_SIGNATURE_FIELDS && (
                    <div>
                        <div style={{border: '1px solid #ddd', borderRight: '1px solid #ddd', minHeight: "80px", textAlign: "center", marginLeft: "5%", marginRight: "5%"}}>
                            ΕΚΔΟΣΗ
                        </div>
                        <div style={{border: '1px solid #ddd', borderRight: '1px solid #ddd', minHeight: "80px", textAlign: "center", marginLeft: "5%", marginRight: "5%", marginTop: "20px"}}>
                            ΠΑΡΑΛΑΒΗ
                        </div>
                    </div>
                )}
                <div style={{height: "50px", borderBottom: "1px dashed black"}}></div>
            </div>
        </React.Fragment>
    )
})

export default ThermalPrint110;